import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("noscript", null, "\n<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-ND4GVCB\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>\n", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", {
  class: "l-header",
  id: "gakumon_header"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "l-header__inner" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "p-gakumon__title" }, "学問分野解説")
  ])
], -1)
const _hoisted_3 = { class: "p-gakumon__contentTitle" }
const _hoisted_4 = { class: "contentTitle_wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "c-button-backToGakumon",
  onclick: "window.close();",
  value: "遷移"
}, "閉じる", -1)
const _hoisted_6 = { class: "p-gakumon__content" }
const _hoisted_7 = { class: "p-gakumon__img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "p-gakumon__info" }
const _hoisted_10 = { class: "p-gakumon__future" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("span", null, "将来")
], -1)
const _hoisted_12 = { class: "p-gakumon__link" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("main", {
      class: _normalizeClass(["l-main", `p-gakumon-type0${_ctx.classFlag}`])
    }, [
      _createElementVNode("section", null, [
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(this.posts.name), 1),
            _hoisted_5
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("figure", _hoisted_7, [
            (this.posts.img1 != null)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                  style: _normalizeStyle(`background-image: url(${this.posts.img1})`)
                }, null, 12, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("dl", _hoisted_9, [
            _createElementVNode("dt", null, _toDisplayString(this.posts.title1), 1),
            _createElementVNode("dd", null, _toDisplayString(this.posts.description1), 1),
            _createElementVNode("dt", null, _toDisplayString(this.posts.title2), 1),
            _createElementVNode("dd", null, _toDisplayString(this.posts.description2), 1)
          ]),
          _createElementVNode("dl", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(this.posts.future), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            href: './result.html?Gm='+this.gakumonBunya+'&SerKbn=0'
          }, "この学問分野の講義を見る", 8, _hoisted_13)
        ]),
        _createVNode(_component_vue_element_loading, {
          active: _ctx.loadingshow,
          color: "rgba(110, 185, 43, .4)",
          size: "120",
          duration: "1.0",
          "is-full-screen": ""
        }, null, 8, ["active"])
      ])
    ], 2)
  ], 64))
}